/* eslint-disable no-console */
import { httpModule, httpModuleFormData } from '@shared/http';
import { Person } from '@/assets/entities';
import { Contract } from '@services/contract';

export interface TenantFilters {
    firstname: string;
    lastname: string;
    document: number;
    email: string;
    telephone: string;
    properties: number[];
}

export type Tenant = {
    id: number;
    cuit: string;
    salary: number;
    afipSituation: string;
    properties: {
        id: number;
        address: string;
        externalReference: number;
        isActive: boolean;
    }[];
    person: Person;
    contracts: Contract[];
};

export async function fetchTenants(
    page?: number,
    limit?: number,
    search?: string,
    firstname?: string,
    lastname?: string,
    document?: number,
    email?: string,
    phone?: string,
    properties?: number[]
) {
    try {
        return await httpModule.get('/tenants', {
            params: {
                page,
                limit,
                search,
                firstname,
                lastname,
                document,
                email,
                phone,
                properties
            }
        });
    } catch (ex) {
        console.warn(`Error fetching tenants`);
        console.log(ex.response);
    }
}

export async function postTenant(tenant: any) {
    try {
        return await httpModule.post('/tenants', tenant);
    } catch (ex) {
        console.warn(`Error posting tenant`);
        console.log(ex.response);
    }
}

export async function patchTenant(tenant: any) {
    try {
        return await httpModule.patch('/tenants', tenant);
    } catch (ex) {
        console.warn(`Error patching tenant`);
        console.log(ex.response);
    }
}

export async function importTeenantToXLSX() {
    try {
        return await httpModule.get('/tenants/import-xlsx');
    } catch (ex) {
        console.warn(`Error while importing tenant's data from an .XLSX file`);
        console.log(ex.response);
    }
}

export async function getTenantByID(id: number) {
    try {
        return await httpModule.get(`/tenants/${id}`);
    } catch (ex) {
        console.warn(`Error getting a tenant`);
        console.log(ex.response);
    }
}

export async function getTenantByPropertyId(id: number) {
    try {
        return await httpModule.get(`/tenants/tenant-by-property/${id}`);
    } catch (ex) {
        console.warn(`Error getting a tenant by property id`);
        console.log(ex.response);
    }
}

export async function deleteTenant(id: number) {
    try {
        return await httpModule.delete(`/tenants/${id}`);
    } catch (ex) {
        console.warn(`Error deleting a tenant`);
        console.log(ex.response);
    }
}

export async function putTenantAttached(f: File, id: number) {
    try {
        const fileForm = new FormData();
        fileForm.append('file', f);
        const config = {
            maxContentLength: 10 * 1024 * 1024 // 10MB
        };
        return await httpModuleFormData.put(`/tenants/${id}`, fileForm, config);
    } catch (ex) {
        console.warn('Error attaching file to tenant', id);
        console.log(ex);
    }
}
